import { ServiceHandler } from 'types'
import { SERVICE_HANDLER_AUTH } from './auth'
import { ServiceParam } from './ServiceParam'

export const SERVICE_HANDLER: ServiceHandler<ServiceParam> = {
  ...SERVICE_HANDLER_AUTH,
}
